import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import {
  getXsollaPremiumEligibilityPath,
  resolveXsollaCheckoutExperience,
  TXsollaCheckoutExperience
} from '../../../common/xsollaRollout';
import { FeatureFlag } from '../../../gameConfig/sharedTypes';
import { claimedCharacterRegionsSelector, useFeature, useSiteConfig } from '../../scripts/selectors/global';

/**
 * Single source of truth for whether a surface offers Xsolla checkout.
 *
 * Eligibility is always resolved against the equivalent /premium path, so a rail on
 * settings or in an article sees the same market as the Premium page rather than
 * failing the premium-path check and silently falling back to Patreon.
 */
export function useXsollaCheckoutExperience(): TXsollaCheckoutExperience {
  const location = useLocation();
  const siteConfig = useSiteConfig();
  const claimedCharacterRegions = useSelector(claimedCharacterRegionsSelector);
  const isInternalTester = !!useFeature(FeatureFlag.XSOLLA_TESTER);
  const eligibilityPath = getXsollaPremiumEligibilityPath(location.pathname);

  return useMemo(
    () =>
      resolveXsollaCheckoutExperience(
        eligibilityPath,
        siteConfig.xsolla,
        siteConfig.country,
        isInternalTester,
        claimedCharacterRegions
      ),
    [claimedCharacterRegions, eligibilityPath, isInternalTester, siteConfig.country, siteConfig.xsolla]
  );
}
